(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["neko-card-color-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const swatch = event.target.closest('[data-neko-card-swatch]');
  if (!swatch) return;

  const card = swatch.closest('.card-wrapper');
  const group = swatch.closest('[data-neko-card-swatches]');
  if (!card || !group) return;

  const image = card.querySelector('.card__media .media > img:first-child');
  if (image && swatch.dataset.imageSrc) {
    image.src = swatch.dataset.imageSrc;
    image.srcset = swatch.dataset.imageSrcset || '';
    image.alt = swatch.dataset.imageAlt || '';
  }

  if (swatch.dataset.variantUrl) {
    card.querySelectorAll('a[href]').forEach((link) => {
      if (link.href.includes('/products/')) link.href = swatch.dataset.variantUrl;
    });
  }

  group.querySelectorAll('[data-neko-card-swatch]').forEach((button) => {
    const active = button === swatch;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["neko-photo-overview-backup"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('neko-photo-overview')){
  customElements.define('neko-photo-overview',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.opener=this.querySelector('.npo-open');
      this.dialog=this.querySelector('dialog');
      this.grid=this.querySelector('.npo-grid');
      this.view=this.querySelector('.npo-view');
      this.back=this.querySelector('.npo-back');
      this.heading=this.querySelector('.npo-title');
      this.tiles=Array.from(this.querySelectorAll('.npo-tile'));
      this.index=0;
      this.opener.hidden=false;
      this.opener.addEventListener('click',()=>{
        this.showGrid(false);
        this.previousOverflow=document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow='hidden';
      });
      this.querySelector('.npo-close').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('close',()=>{
        document.documentElement.style.overflow=this.previousOverflow||'';
        this.opener.focus({preventScroll:true});
      });
      this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
      this.tiles.forEach((tile,index)=>tile.addEventListener('click',()=>{this.showPhoto(index);this.back.focus();}));
      this.back.addEventListener('click',()=>this.showGrid(true));
      this.querySelector('.npo-prev').addEventListener('click',()=>this.showPhoto(this.index-1));
      this.querySelector('.npo-next').addEventListener('click',()=>this.showPhoto(this.index+1));
      this.dialog.addEventListener('keydown',e=>{
        if(this.view.hidden)return;
        if(e.key==='ArrowLeft'){e.preventDefault();this.showPhoto(this.index-1);}
        if(e.key==='ArrowRight'){e.preventDefault();this.showPhoto(this.index+1);}
      });
      let start;
      this.view.addEventListener('touchstart',e=>{start=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{passive:true});
      this.view.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5)this.showPhoto(this.index+(dx<0?1:-1));start=null;},{passive:true});
    }
    showGrid(focus){
      this.grid.hidden=false;this.view.hidden=true;this.back.hidden=true;this.heading.hidden=false;
      if(focus)this.tiles[this.index].focus({preventScroll:true});
    }
    showPhoto(index){
      this.index=(index+this.tiles.length)%this.tiles.length;
      const tile=this.tiles[this.index],img=this.querySelector('.npo-large');
      img.src=tile.dataset.full;img.alt=tile.querySelector('img').alt;
      this.grid.hidden=true;this.view.hidden=false;this.back.hidden=false;this.heading.hidden=true;
      this.querySelector('.npo-count').textContent=(this.index+1)+' / '+this.tiles.length;
    }
    disconnectedCallback(){if(this.dialog?.open)document.documentElement.style.overflow=this.previousOverflow||'';}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["neko-photo-overview"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('neko-photo-overview')){
  customElements.define('neko-photo-overview',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.opener=this.querySelector('.npo-open');
      this.dialog=this.querySelector('dialog');
      this.grid=this.querySelector('.npo-grid');
      this.view=this.querySelector('.npo-view');
      this.back=this.querySelector('.npo-back');
      this.heading=this.querySelector('.npo-title');
      this.tiles=Array.from(this.querySelectorAll('.npo-tile'));
      this.index=0;
      this.opener.hidden=false;
      this.stage=this.closest('.npo-stage');
      if(this.stage){
        this.alignPhoto=()=>{
          cancelAnimationFrame(this.alignFrame);
          this.alignFrame=requestAnimationFrame(()=>{
            const active=this.stage.querySelector('.product__media-item.is-active')||this.stage.querySelector('.product__media-item');
            const photo=active?.querySelector('.product__media')||active;
            if(!photo)return;
            const outer=this.stage.getBoundingClientRect(), rect=photo.getBoundingClientRect();
            if(!rect.width||!rect.height)return;
            const inset=14;
            this.style.setProperty('--npo-right',Math.max(inset,outer.right-rect.right+inset)+'px');
            this.style.setProperty('--npo-bottom',Math.max(inset,outer.bottom-rect.bottom+inset)+'px');
          });
        };
        this.sizeObserver=new ResizeObserver(this.alignPhoto);
        this.sizeObserver.observe(this.stage);
        this.stage.querySelectorAll('.product__media').forEach(el=>this.sizeObserver.observe(el));
        this.mediaObserver=new MutationObserver(this.alignPhoto);
        this.mediaObserver.observe(this.stage.querySelector('ul'),{subtree:true,attributes:true,attributeFilter:['class','src'],childList:true});
        this.stage.addEventListener('scroll',this.alignPhoto,true);
        this.alignPhoto();
      }
      this.opener.addEventListener('click',()=>{
        this.showGrid(false);
        this.previousOverflow=document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow='hidden';
      });
      this.querySelector('.npo-close').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('close',()=>{
        document.documentElement.style.overflow=this.previousOverflow||'';
        this.opener.focus({preventScroll:true});
      });
      this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
      this.tiles.forEach((tile,index)=>tile.addEventListener('click',()=>{this.showPhoto(index);this.back.focus();}));
      this.back.addEventListener('click',()=>this.showGrid(true));
      this.querySelector('.npo-prev').addEventListener('click',()=>this.showPhoto(this.index-1));
      this.querySelector('.npo-next').addEventListener('click',()=>this.showPhoto(this.index+1));
      this.dialog.addEventListener('keydown',e=>{
        if(this.view.hidden)return;
        if(e.key==='ArrowLeft'){e.preventDefault();this.showPhoto(this.index-1);}
        if(e.key==='ArrowRight'){e.preventDefault();this.showPhoto(this.index+1);}
      });
      let start;
      this.view.addEventListener('touchstart',e=>{start=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{passive:true});
      this.view.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5)this.showPhoto(this.index+(dx<0?1:-1));start=null;},{passive:true});
    }
    showGrid(focus){
      this.grid.hidden=false;this.view.hidden=true;this.back.hidden=true;this.heading.hidden=false;
      if(focus)this.tiles[this.index].focus({preventScroll:true});
    }
    showPhoto(index){
      this.index=(index+this.tiles.length)%this.tiles.length;
      const tile=this.tiles[this.index],img=this.querySelector('.npo-large');
      img.src=tile.dataset.full;img.alt=tile.querySelector('img').alt;
      this.grid.hidden=true;this.view.hidden=false;this.back.hidden=false;this.heading.hidden=true;
      this.querySelector('.npo-count').textContent=(this.index+1)+' / '+this.tiles.length;
    }
    disconnectedCallback(){this.sizeObserver?.disconnect();this.mediaObserver?.disconnect();cancelAnimationFrame(this.alignFrame);this.stage?.removeEventListener('scroll',this.alignPhoto,true);if(this.dialog?.open)document.documentElement.style.overflow=this.previousOverflow||'';}
  });
}
  } catch(e) { console.error(e); }
})();

})();
